import React, { useEffect, useState } from 'react';
import './NewsLetter.css';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'sonner';

const NewsLetter = () => {
  const [showNewsletterPopup, setShowNewsletterPopup] = useState(false);
  const [email, setEmail] = useState('');
  const [posterImage, setPosterImage] = useState([]);
  const [showPosterPopup, setShowPosterPopup] = useState(false);

  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem('hasSeenPromoPopup');
    if (hasSeenPopup) return;

    const fetchPoster = async () => {
      try {
        const response = await fetch('https://admin.ezerautomotive.co.nz/api/poster-image/');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const result = await response.json();
        console.log(result.poster_image, 'popup img');

        if (result?.poster_image) {
          setPosterImage(`https://admin.ezerautomotive.co.nz${result.poster_image}`);
          setShowPosterPopup(true);
          sessionStorage.setItem('hasSeenPromoPopup', 'true');
        } else {
          console.warn('poster_image key not found');
        }
      } catch (err) {
        console.error('Poster fetch error:', err.message);
      }
    };

    fetchPoster();
  }, []);


  const closePosterPopup = () => {
    setShowPosterPopup(false);
    
    // Don't show newsletter if they already subscribed
    const hasSubscribed = localStorage.getItem('hasSubscribedNewsLetter');
    if (hasSubscribed) return;

    setTimeout(() => {
      setShowNewsletterPopup(true);
    }, 10000);
  };

  const closeNewsletterPopup = () => setShowNewsletterPopup(false);

  const handleSubscribe = async () => {
    if (!email) return toast.warning('Please enter your email address.');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return toast.error('Please enter a valid email address.');

    try {
      const response = await fetch('https://admin.ezerautomotive.co.nz/api/subscribe/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) throw new Error('Failed to subscribe');

      const data = await response.json();
      console.log('Subscription successful:', data);
      toast.success('Subscribed successfully!');
      localStorage.setItem('hasSubscribedNewsLetter', 'true');
      setShowNewsletterPopup(false);
      setEmail('');
    } catch (error) {
      console.error('Subscription error:', error.message);
      toast.error('Subscription failed. Please try again later.');
    }
  };

  return (
    <AnimatePresence>
      {/* Poster Image Popup */}
      {showPosterPopup && (
        <motion.div
          className="image-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="image-popup"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button className="close-btns" onClick={closePosterPopup}>&times;</button>
            <img src={posterImage} alt="Poster" style={{
              width: '100%',
              height: 'auto',
              maxHeight: '80vh',
              objectFit: 'contain',
              borderRadius: '8px'
            }} />
          </motion.div>
        </motion.div>
      )}

      {/* Newsletter Popup */}
      {showNewsletterPopup && (
        <motion.div
          className="newsletter-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="newsletter-popup"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <button className="close-btn" onClick={closeNewsletterPopup}>
              &times;
            </button>
            <h2 className="chakra-petch-semibold">Join our newsletter</h2>
            <p className="font-mulish">
              Register now to get latest updates on promotions & coupons.
              <br />
              Don’t worry, we not spam!
            </p>
            <input
              type="email"
              placeholder="Enter Your Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="font-mulish"
            />
            <button
              className="subscribe-btn chakra-petch-semibold"
              onClick={handleSubscribe}
            >
              Subscribe
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NewsLetter;
